export const SHOW_SELECTOR = 'PROFILESELECTOR_SHOW_SELECTOR'
export const HIDE_SELECTOR = 'PROFILESELECTOR_HIDE_SELECTOR'
export const TOGGLE_SELECTOR = 'PROFILESELECTOR_TOGGLE_SELECTOR'
export const SET_MANAGE_PROFILES_TEXT = 'PROFILESELECTOR_SET_MANAGE_PROFILES_TEXT'



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/data/constants.js